import CONFIG from "../config/config";
import { apiFetch } from "./http";

/**
 * Guest submission of a run review (delivery or patrol).
 *   POST /api/v1/reviews — gated by verifyV1Token only, since a guest portal
 *   session carries a plain `user` role that the admin portal denies outright.
 *
 * `deliveryId` is best-effort: this app often has no Delivery record, and the
 * backend falls back to the most recently completed run for the serialID. That
 * fallback is why `type` matters for correctness rather than labelling — a
 * patrol creates no Delivery row, so 'patrol' suppresses the lookup instead of
 * attaching the review to an unrelated delivery.
 */

const BASE_URL = `${CONFIG.BASE_URL}/api/v1/reviews`;

const authHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("portalToken")}`,
});

/**
 * @param {object} review
 * @param {string} review.serialID
 * @param {string|null} [review.deliveryId]
 * @param {number} review.rating
 * @param {string} [review.comment]
 * @param {'delivery'|'patrol'} [review.type] Defaults to 'delivery'.
 * @param {{roundsCompleted?: number|null, totalRounds?: number|null,
 *          waypointCount?: number|null, cancelled?: boolean}|null} [review.patrolSummary]
 *        Patrol runs only — ignored by the backend for a delivery.
 */
export const submitReview = async ({
  serialID,
  deliveryId = null,
  rating,
  comment = "",
  type = "delivery",
  patrolSummary = null,
}) => {
  const res = await apiFetch(BASE_URL, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({
      serialID,
      deliveryId,
      rating,
      comment,
      platform: "user-fe",
      type,
      patrolSummary,
    }),
  });
  if (!res.ok) throw new Error("Failed to submit review");
  return res.json();
};
